import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  icon?: boolean;
}
export const CHECKOUT_URL = 'https://lumara-belleza.shop/checkouts/cn/hWNBVuYDzCwqtSXzXfYzMNGc/es-ar?_r=AQABlnwr2yZQ2EUuLyh9ay0DgW3jYXgpoS0z6dET0_Wq7hA&preview_theme_id=159088541929';
export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  fullWidth = false,
  icon = true
}) => {
  const handleClick = () => {
    trackAddToCart();
  };
  return <motion.a href={CHECKOUT_URL} onClick={handleClick} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} className={`
        group relative inline-flex items-center justify-center gap-3
        bg-text-dark text-cream font-serif text-xl md:text-2xl font-bold
        px-8 py-5 rounded-full shadow-[0_8px_30px_rgb(61,43,31,0.2)]
        hover:bg-text-brown transition-all duration-300 overflow-hidden
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-46">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-47" />
      <span className="relative z-10" data-id="element-48">{children}</span>
      {icon && <ArrowRight className="relative z-10 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-49" />}
    </motion.a>;
};